import * as React from 'react';

import { RadioGroupContext } from './RadioGroup';
import classes from './RadioButton.scss';

type IndicatorPosition = 'left' | 'right';

type Props = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> & {
  children?: React.ReactNode;
  indicatorPosition?: IndicatorPosition;
  inputClassName?: string;
};

const RadioButton = React.forwardRef<HTMLInputElement, Props>(
  ({ children, indicatorPosition = 'right', className, inputClassName, name, disabled, ...rest }, ref) => {
    const group = React.useContext(RadioGroupContext);
    const resolvedName = group?.name ?? name;

    const indicatorClassName =
      indicatorPosition === 'right' ? classes['radioButton--indicator-right'] : classes['radioButton--indicator-left'];

    const wrapperClassNames = [classes['radioButton'], indicatorClassName];
    if (disabled) {
      wrapperClassNames.push(classes['radioButton--disabled']);
    }
    if (className) {
      wrapperClassNames.push(className);
    }

    const inputClassNames = [classes['radioButton__input'], inputClassName].filter(Boolean).join(' ');

    return (
      <label className={wrapperClassNames.join(' ')}>
        <input
          {...rest}
          ref={ref}
          type="radio"
          name={resolvedName}
          className={inputClassNames}
          disabled={disabled}
        />
        <span className={classes['radioButton__content']}>{children}</span>
        <span className={classes['radioButton__indicatorWrapper']}>
          <span
            className={classes['radioButton__indicator']}
            aria-hidden="true"
          />
        </span>
      </label>
    );
  }
);

RadioButton.displayName = 'RadioButton';

export default RadioButton;
